<div [class.overview]="activeRoom" class="fullwidth" id="top">
  <div class="top" [class.gradient-top]="colors.primaryColor2">
    <div class="headline">
      <h1 *ngIf="!activeWorkshop.partOfCollection" class="overline">{{ activeWorkshop.overline }}</h1>
      <div class="backButtonWrapper" *ngIf="activeWorkshop.partOfCollection">
        <button mat-icon-button routerLink="..">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <h1 class="overline">{{ activeWorkshop.overline }}</h1>
      </div>
      <h1>{{ activeWorkshop.headline }}</h1>
      <p [innerHtml]="activeWorkshop.text | safeHTML"></p>
      <p [innerHtml]="activeWorkshop.disclaimer | safeHTML"></p>
    </div>
  </div>
  <div class="workshop-rooms bottom" *ngIf="loaded">
    <div class="workshop-room card" *ngFor="let room of activeWorkshop.rooms; let i = index">
      <img *ngIf="room.settings.imgURL && mobile" [src]="room.settings.imgURL | safe" />
      <img
        *ngIf="room.settings.imgURL && !mobile"
        [src]="room.settings.imgURL | safe"
        (click)="switch(room)"
        [matTooltip]="activeWorkshop.captionEnter"
      />
      <div style="height: 100%; overflow: auto;">
        <h2 class="room-title" (click)="switch(room)" [matTooltip]="activeWorkshop.captionEnter">{{ room.name }}</h2>
        <p
          id="{{ 'description' + i }}"
          *ngIf="room.description"
          [class.showDesc]="i == expanded"
          [innerHtml]="room.description | safeHTML"
        ></p>
      </div>

      <!-- Important, gives the room name appropriate margin if no description is present -->
      <p *ngIf="!room.description"></p>
      <button
        mat-button
        class="showMore"
        *ngIf="mobile && !(i == expanded) && document.getElementById('description' + i)?.offsetHeight >= 100"
        (click)="expanded = i"
      >
        <mat-icon>expand_more</mat-icon>
      </button>
      <button mat-button class="showMore" *ngIf="mobile && i == expanded" (click)="expanded = -1"><mat-icon>expand_less</mat-icon></button>
      <button id="workshopEnter" class="enterButton" (click)="switch(room)">{{ activeWorkshop.captionEnter }}</button>
    </div>
  </div>
</div>
<div *ngIf="activeRoom" class="fullwidth">
  <button (click)="switch(undefined)" class="fullsize-button" [class.gradient-top]="colors.primaryColor2">
    {{ activeWorkshop.backButtonText }}
  </button>
</div>
<app-bigbluebutton [openFromBooth]="false" [room]="activeRoom" *ngIf="activeRoom"></app-bigbluebutton>
